import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DealContactRoleRequest, DealContactRoleResponse } from '../models/deal-contact-role.model';

@Injectable({ providedIn: 'root' })
export class DealContactRoleApiService {
  private readonly apiUrl = `${environment.apiUrl}api/deal-contact-roles`;

  constructor(private http: HttpClient) {}

  getAll(businessId: number): Observable<DealContactRoleResponse[]> {
    const params = new HttpParams().set('businessId', businessId);
    return this.http.get<DealContactRoleResponse[]>(this.apiUrl, { params });
  }

  getAllActive(businessId: number): Observable<DealContactRoleResponse[]> {
    const params = new HttpParams().set('businessId', businessId);
    return this.http.get<DealContactRoleResponse[]>(`${this.apiUrl}/active`, { params });
  }

  getById(id: number, businessId: number): Observable<DealContactRoleResponse> {
    const params = new HttpParams().set('businessId', businessId);
    return this.http.get<DealContactRoleResponse>(`${this.apiUrl}/${id}`, { params });
  }

  create(req: DealContactRoleRequest): Observable<DealContactRoleResponse> {
    return this.http.post<DealContactRoleResponse>(this.apiUrl, req);
  }

  update(id: number, businessId: number, req: DealContactRoleRequest): Observable<DealContactRoleResponse> {
    const params = new HttpParams().set('businessId', businessId);
    return this.http.put<DealContactRoleResponse>(`${this.apiUrl}/${id}`, req, { params });
  }

  activate(id: number, businessId: number): Observable<DealContactRoleResponse> {
    const params = new HttpParams().set('businessId', businessId);
    return this.http.post<DealContactRoleResponse>(`${this.apiUrl}/${id}/activate`, {}, { params });
  }

  deactivate(id: number, businessId: number): Observable<DealContactRoleResponse> {
    const params = new HttpParams().set('businessId', businessId);
    return this.http.post<DealContactRoleResponse>(`${this.apiUrl}/${id}/deactivate`, {}, { params });
  }

  delete(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId);
    return this.http.delete<void>(`${this.apiUrl}/${id}`, { params });
  }

  // POST /api/deal-contact-roles/reorder?businessId= — body: ids en el nuevo orden (lista COMPLETA).
  // El backend asigna display_order por posición empezando en 1. Responde 204 sin body.
  reorder(businessId: number, orderedIds: number[]): Observable<void> {
    const params = new HttpParams().set('businessId', businessId);
    return this.http.post<void>(`${this.apiUrl}/reorder`, orderedIds, { params });
  }
}
